import { render, staticRenderFns } from "./taxConfirmDialog.vue?vue&type=template&id=18a7d547&scoped=true"
import script from "./taxConfirmDialog.vue?vue&type=script&lang=js"
export * from "./taxConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./taxConfirmDialog.vue?vue&type=style&index=0&id=18a7d547&prod&lang=less"
import style1 from "./taxConfirmDialog.vue?vue&type=style&index=1&id=18a7d547&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7d547",
  null
  
)

export default component.exports